class KlevuFilters extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (this?.els?.trigger?.exists) {
      this.els.trigger.elements.forEach(triggerEl => {
        this.listeners.add(
          triggerEl,
          `click`,
          this.handleFilterClick.bind(this),
        )
      })
    }
  }

  handleFilterClick (e) {
    const selectedValue = e.currentTarget.dataset.value

    const correspondingDiv = document.querySelector(
      `.klevuFilterOption[data-value="${selectedValue}"]`,
    )

    if (correspondingDiv) {
      correspondingDiv.click()
    }
  }
}

if (!customElements.get('klevu-filters')) {
  customElements.define('klevu-filters', KlevuFilters)
}
